import * as React from 'react';

import OfferDashboard from './OfferDashboard';

const OfferRouter = {
    path: 'admin/offres',
    element: <OfferDashboard />,
    handle: { title: 'Offres' },
};

export default OfferRouter;
